import pako from "pako";
//Pretty much entirely stolen from merchtech

function deflateDocument(document) {
    const dataJson = JSON.stringify(document);
    const dataDeflated = encodeURIComponent(btoa(pako.deflateRaw(dataJson, { to: "string" })));
    return dataDeflated;
}

function generatePreviewUrl(deflatedDocument, width) {
    const previewInstructions = `https://uds.documents.cimpress.io/v3/instructions:preview?documentUri=${deflatedDocument}`
    return `https://rendering.documents.cimpress.io/v1/cse/preview?width=300&instructions_uri=${encodeURIComponent(previewInstructions)}`;
}

async function getDocFromId(docId){
    const safeDocId = encodeURIComponent(docId);
    const url = `https://uds.documents.cimpress.io/v3/documents/${safeDocId}?normalize=false&unit=mm`;
    
    return (await fetch(url, {
        method: 'GET'
    })).json();
}

export async function GetProductInformationFromCimdoc(docId) {
    const document = await getDocFromId(docId);

    const surfacesBeingUsed = document.document.surfaces.filter(surface => document.metadata.usedPanels.includes(surface.id));
    const productsBeingDesigned = document.metadata.usedPanels.map(panel => getSocialMediaProductNameFromSurfaceId(panel));
    const previewUrls = surfacesBeingUsed.map(surface => {
        const tempDocument = {
            fontRepositoryUrl: document.fontRepositoryUrl,
            version: document.version,
            document: { surfaces: [surface] }
        };
        return generatePreviewUrl(deflateDocument(tempDocument), parseFloat(surface.width) * 10.0);
    });

    return {'previewUrls': previewUrls, 'productsFromProvidedCimdoc': productsBeingDesigned}
}

function getSocialMediaProductNameFromSurfaceId(surfaceId)
{
    switch(surfaceId)
    {
        case "instagramPost":
            return "Instagram Post";
        case "facebookPost":
            return "Facebook Post";
        case "twitterPost":
                return "Twitter Post";
        case "zoomBackground":
            return "Zoom Background";
        case "linkedInPost":
            return "LinkedIn Post";
        case "instagramStory":
            return "Instagram Story";
        default:
            return "unknown";
    }
}



// WEBPACK FOOTER //
// ./src/services/CimdocRenderingService.js